import { Component, ElementRef, EventEmitter, Input, Output } from "@angular/core";
import { SubtaskModel, SubtaskComment } from "../../service/task-mgmt.service";

@Component({
  selector: "app-subtask-list",
  templateUrl: "./subtask-list.component.html",
  styleUrls: ["./subtask-list.component.scss"],
})
export class SubtaskListComponent {
  @Input() subtasks: SubtaskModel[] = [];
  @Input() isViewMode = false;
  @Input() isEditMode = false;
  @Input() isCreateMode = false;
  @Input() editingSubtaskId: string | null = null;
  @Input() currentUserName = "";
  @Input() currentTaskId = "";

  @Output() subtasksChange = new EventEmitter<SubtaskModel[]>();
  @Output() addSubtaskRequested = new EventEmitter<void>();
  @Output() editSubtaskRequested = new EventEmitter<string>();

  constructor(private el: ElementRef) {}

  get hasIncompleteSubtasks(): boolean {
    return (
      this.subtasks.length > 0 &&
      this.subtasks.some(
        (st) => st.status !== "done" && st.status !== "cancelled"
      )
    );
  }

  trackBySubtaskId(index: number, st: SubtaskModel): string {
    return st.subtask_id;
  }

  addSubtask(): void {
    if (this.isViewMode) {
      this.addSubtaskRequested.emit();
      return;
    }

    const newId = `${this.currentTaskId || "NEW"}-ST${(this.subtasks.length + 1)
      .toString()
      .padStart(3, "0")}`;

    const newSubtask: SubtaskModel = {
      subtask_id: newId,
      name: "",
      taskType: "",
      startDate: null,
      endDate: null,
      remindMe: false,
      remindDate: null,
      remindTime: null,
      priorityLevel: "medium",
      status: "planned",
      assignTo: "",
      tagType: "",
      tags: [],
      description: "",
      attachments: [],
      comments: [],
    };

    this.subtasks = [...this.subtasks, newSubtask];
    this.subtasksChange.emit(this.subtasks);

    // Auto-focus new subtask name input after DOM updates
    setTimeout(() => {
      const inputs = this.el.nativeElement.querySelectorAll('.subtask-name-input');
      const lastInput = inputs[inputs.length - 1];
      if (lastInput) lastInput.focus();
    }, 150);
  }

  onSubtaskChange(updated: SubtaskModel, index: number): void {
    this.subtasks[index] = updated;
    this.subtasksChange.emit(this.subtasks);
  }

  onRemoveSubtask(index: number): void {
    this.subtasks.splice(index, 1);
    this.subtasks = [...this.subtasks];
    this.subtasksChange.emit(this.subtasks);
  }

  onEditSubtaskRequested(subtaskId: string): void {
    this.editSubtaskRequested.emit(subtaskId);
  }

  onCommentAdded(event: { index: number; comment: SubtaskComment }): void {
    const st = this.subtasks[event.index];
    st.comments = [...(st.comments || []), event.comment];
    this.subtasksChange.emit(this.subtasks);
  }
}
